import { render, staticRenderFns } from "./CommunitiesInfos.vue?vue&type=template&id=696170ca&scoped=true"
import script from "./CommunitiesInfos.vue?vue&type=script&lang=js"
export * from "./CommunitiesInfos.vue?vue&type=script&lang=js"
import style0 from "./CommunitiesInfos.vue?vue&type=style&index=0&id=696170ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696170ca",
  null
  
)

export default component.exports